import { object, array, string } from '@gogame/schemas';

import {
  COLUMN_FINAL,
  COLUMN_CURRENT,
  COLUMN_STATUS,
  COLUMN_COMMENT,
  COLUMN_DATE_UPDATED,
  COLUMN_AUTHOR,
  COLUMN_DATE_CREATED,
} from '../constants';

export const columnsSchema = object({
  order: array(string()).default([
    COLUMN_FINAL,
    COLUMN_CURRENT,
    COLUMN_STATUS,
    COLUMN_COMMENT,
    COLUMN_DATE_UPDATED,
    COLUMN_AUTHOR,
    COLUMN_DATE_CREATED,
  ]),
  collapsed: array(string()).default([]),
});
